import { render, staticRenderFns } from "./SupervisorDetail.vue?vue&type=template&id=244ee3aa"
import script from "./SupervisorDetail.vue?vue&type=script&lang=js"
export * from "./SupervisorDetail.vue?vue&type=script&lang=js"
import style0 from "./SupervisorDetail.vue?vue&type=style&index=0&id=244ee3aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports